import type { CombinedItem } from "./item-helpers"
import { ReviewStatus } from "../types/shared"

export interface ReviewItemData {
  item_type: string
  item_id: number
  review_id: number
  review_notes: string
  status: ReviewStatus
}

export const buildReviewData = (
  selectedItems: Set<number>,
  allItems: CombinedItem[],
  reviewNotes: Record<number, string>,
  globalNote: string
): ReviewItemData[] => {
  return Array.from(selectedItems).map((itemId) => {
    const item = allItems.find((i) => i.id === itemId)

    if (!item) {
      throw new Error(`Item ${itemId} not found`)
    }

    return {
      item_type: item.type,
      item_id: item.item_id,
      review_id: item.review_id,
      review_notes: reviewNotes[itemId] || globalNote || "Item rejeitado",
      status: ReviewStatus.REJECTED,
    }
  })
}
